<template>
  <div class="container">
      <!-- 头部 -->
      <div class="header">
        <div class="header-info d-f a-c j-s">
            <img class="header-logo" src="static/img/header_logo.png" alt="">
            <div class="menu d-f a-c">
                <div class="menu-item">
                  <div class="menu-line" :class="currentIndex==0?'menu-line-active':''" @click="changeCurrentIndex(0)"></div>
                  <div class="menu-title" :class="currentIndex==0?'menu-title-active':''" @click="changeCurrentIndex(0)">Inicio</div>
                </div>
                <div class="menu-item">
                  <div class="menu-line" :class="currentIndex==1?'menu-line-active':''" @click="changeCurrentIndex(1)"></div>
                  <div class="menu-title" :class="currentIndex==1?'menu-title-active':''" @click="changeCurrentIndex(1)">Características</div>
                </div>
                <div class="menu-item">
                  <div class="menu-line" :class="currentIndex==2?'menu-line-active':''" @click="changeCurrentIndex(2)"></div>
                  <div class="menu-title" :class="currentIndex==2?'menu-title-active':''" @click="changeCurrentIndex(2)">uestra ventaja</div>
                </div>
                <div class="menu-item">
                  <div class="menu-line" :class="currentIndex==3?'menu-line-active':''" @click="changeCurrentIndex(3)"></div>
                  <div class="menu-title" :class="currentIndex==3?'menu-title-active':''" @click="changeCurrentIndex(3)">Proceso</div>
                </div>
            </div>
        </div>
        <!-- banner部分 -->
            <div class="d-f j-c a-c" style="margin-top:.81rem;">
              <div>
                  <img class="header-title" src="static/img/header_title.png" alt="">
                  <div class="header-desc">No se necesita ninguna hipoteca, solo proporcione su INE/IFE. La revisión online será pasada en minutos.</div>
                  <div class="d-f a-c" style="margin-top:.26rem">
                    <img class="app-store" src="static/img/app_store.png" alt="">
                    <img class="google-play" src="static/img/google_play.png" alt="">
                  </div>
              </div>
              <div>
                  <img class="header-banner" src="static/img/header_banner.png" alt="">
              </div>
            </div>
      </div>

      <img id="jump1" class="body1-img" src="static/img/body1.png" alt="">
      <div style="position:relative;">
          <img class="body1_bg" src="static/img/body1_bg.png" alt="">
          <div class="d-f a-c j-c">
            <div class="body1_left d-f f-c">
                <img class="body1-left" src="static/img/body1_left.png" alt="">
                <div class="body1-left-title">PASOS SENCILLOS</div>
                <div class="body1-left-desc">Operación simple y rápida</div>
                <div class="d-f a-c" style="margin-top: 0.09rem;">
                  <img class="checkout-img" src="static/img/checkout.png" alt="">
                  <div class="checkout-desc">Descargue, instale la aplicación y solicite un préstamo rápido</div>
                </div>
                <div class="d-f a-c" style="margin-top: 0.09rem;">
                  <img class="checkout-img" src="static/img/checkout.png" alt="">
                  <div class="checkout-desc">Se aprueba sus archivos automáticamente</div>
                </div>
                <div class="d-f a-c" style="margin-top: 0.09rem;">
                  <img class="checkout-img" src="static/img/checkout.png" alt="">
                  <div class="checkout-desc">El sistema decide automáticamente el monto del préstamo.</div>
                </div>
            </div>
            <div>
              <img class="body1-right" src="static/img/body1_right.png" alt="">
            </div>
          </div>

          <div class="d-f a-c j-c" style="margin-top:.16rem;">
            <div>
              <img class="body2-left" src="static/img/body2_left.png" alt="">
            </div>
            <div class="body2_right d-f f-c" style="margin-left:.81rem;">
                <img class="body1-left" src="static/img/body2_right.png" alt="">
                <div class="body1-left-title">INTERÉS BAJO</div>
                <div class="body1-left-desc">Interés bajo</div>
                <div class="d-f a-c" style="margin-top: 0.21rem;">
                  <img class="checkout-img" src="static/img/checkout.png" alt="">
                  <div class="checkout-desc">Nuestro interés es muy atractivo y ofrecemos ofertas especiales</div>
                </div>
                <div class="d-f a-c" style="margin-top: 0.09rem;">
                  <img class="checkout-img" src="static/img/checkout.png" alt="">
                  <div class="checkout-desc">El proceso es sencillo, solo se necesita su DNI</div>
                </div>
            </div>
          </div>

          <div class="d-f a-c j-c">
            <div class="body1_left d-f f-c">
                <img class="body1-left" src="static/img/body3_left.png" alt="">
                <div class="body1-left-title">PRÉSTAMO RÁPIDO</div>
                <div class="body1-left-desc">Préstamo rápido</div>
                <div class="d-f a-s" style="margin-top: 0.22rem;">
                  <img class="checkout-img" src="static/img/checkout.png" alt="">
                  <div class="checkout-desc">
                    <div class="checkout-desc">
                      El depósito llegará inmediatamente a su cuenta bancaria
                    </div>
                    <div class="checkout-desc" style="margin-top:.03rem;">
                      una vez que se apruebe el sistema.
                    </div>
                  </div>
                </div>
            </div>
            <div>
              <img class="body1-right" src="static/img/body3_right.png" alt="">
            </div>
          </div>

      </div>

      <div  id="jump2" class="info d-f f-c a-c j-c">
          <img  class="info-img" src="static/img/info.png" alt="">
          <div class="info-title">Solo se necesitan tres sencillos pasos para completar el préstamo</div>
          <div class="d-f j-c" style="margin-top:.32rem;">
              <div class="info-item d-f f-c a-c">
                  <img class="info-item-img" src="static/img/info1.png" alt="">
                  <div class="info-item-title">Información básica</div>
                  <div class="info-item-desc">Solo 5 minutos</div>
              </div>
              <img class="info1-line" style="margin-left:.21rem;margin-right:.15rem;margin-top:.16rem;" src="static/img/info1_left.png" alt="">
              <div class="info-item d-f f-c a-c">
                  <img class="info-item-img" src="static/img/info2.png" alt="">
                  <div class="info-item-title">Aprobación rápida</div>
                  <div class="info-item-desc">Aprobación en 2 horas</div>
              </div>
              <img class="info1-line" style="margin-left:.21rem;margin-right:.15rem;margin-top:.32rem;" src="static/img/info1_right.png" alt="">
              <div class="info-item d-f f-c a-c">
                  <img class="info-item-img" src="static/img/info3.png" alt="">
                  <div class="info-item-title">Préstamo</div>
                  <div class="info-item-desc">Llegará dentro de 24 hrs</div>
              </div>
          </div>
      </div>
      <!--  -->

       <div  style="position:relative;margin-top:.52rem;">
          <img  id="jump3" class="info2_title" src="static/img/info2_title.png" alt="">
          <img style="top:0.69rem;" class="body1_bg" src="static/img/body1_bg.png" alt="">
          <img class="info-left" src="static/img/info_left.png" alt="">
          <div class="d-f a-c" style="margin-top:.57rem;">
            <img class="info2-left" src="static/img/info2_left.png" alt="">
            <div class="d-f f-wrap">
                <div class="info2-item info2-item-border d-f f-c a-s">
                  <img class="info2-img" src="static/img/info2_1.png" alt="">
                  <div class="info2-item-title">Múltiples opciones</div>
                  <div class="info2-item-desc">Puede elegir la cantidad y el límite de tiempo</div>
                </div>
                <div class="info2-item d-f f-c a-s">
                  <img class="info2-img" src="static/img/info2_2.png" alt="">
                  <div class="info2-item-title" style="width: 1.43rem;">préstamo</div>
                  <div class="info2-item-desc">Puede solicitar todos los días, no se preocupes por los fines de semana y vacaciones</div>
                </div>
                <div class="info2-item d-f f-c a-s">
                  <img class="info2-img" src="static/img/info2_3.png" alt="">
                  <div class="info2-item-title">Servicio todo el día</div>
                  <div class="info2-item-desc">Solo necesita enviar una solicitud, le atentaremos dentro de 24 horas</div>
                </div>
                <div class="info2-item d-f f-c a-s">
                  <img class="info2-img" src="static/img/info2_4.png" alt="">
                  <div class="info2-item-title">En cualquier momento</div>
                  <div class="info2-item-desc">Puede solicitar un préstamo en cualquier momento</div>
                </div>
            </div>
          </div>

          <div class="d-f a-c">
                  <div class="d-f a-c j-c" style="margin-top:.45rem;width:100%;">
                    <img class="app-store" src="static/img/app_store.png" alt="">
                    <img class="google-play" src="static/img/google_play2.png" alt="">
                  </div>
          </div>

      </div>


      <div class="footer d-f f-c a-c">
        <img class="footer-img" src="static/img/footer_title.png" alt="">
        <div class="footer-desc">Con el fin de satisfacer las necesidades de consumo personal de nuestros estimados clientes, brindaremos servicios de consultoría financiera y</div>
        <div class="footer-desc footer-desc2">préstamo. No se requiere recibo de ingresos, solo solicite online y proporcione información de identificación, y recibirá el préstamo de inmediato.</div>
        <img @click="goIndex" class="allow-img" src="static/img/arrow.png" alt="">
      </div>

      <div class="footer2 d-f f-c a-c j-c">
          <div class="footer2-title">Contáctenos: credicashmx@gmail.com</div>
          <div class="footer2-title">NABOO MAGMATICO S.A. DE C.V.</div>
          <div class="footer2-title">Dirección: COAHUILA 111, NA, ROMA NORTE, CUAUHTEMOC, C. P. 06700, CIUDAD DE MEXICO</div>
          <div class="footer2-desc">Hora de trabajo: 9: 00-18: 00 (días hábiles)</div>
          <div class="footer2-info d-f a-c j-s">
            <!-- <div class="footer2-info-desc">Términos de servicio</div> -->
            <div class="footer2-info-desc" @click="goPrivacy">Política de privacidad</div>
          </div>
      </div>
  </div>
</template>
<script>
export default {
  name: "home",
  data() {
    return {
        currentIndex:0,
    };
  },
  created() {},
  methods: {
    changeCurrentIndex(index){
      this.currentIndex = index
      if(index!=0){
      document.querySelector("#jump"+index).scrollIntoView(true);
      }
    },
    goIndex(){
         let distance = document.documentElement.scrollTop || document.body.scrollTop; //获得当前高度
        let step = distance / 30; //每步的距离
        (function jump() {
            if (distance > 0) {
                distance -= step;
                window.scrollTo(0, distance);
                setTimeout(jump, 10);
            }
        })();
        this.currentIndex = 0
    },
    goGoogle(){
      location.href="https://play.google.com/store/apps/details?id=prestamo.credit.dinero.efectivo.credito.rapicredit.lineru.rappicash.prestamos"
    },
    goPrivacy(){
      var u = navigator.userAgent, app = navigator.appVersion;
      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
      var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isIOS) {
          location.href="https://www.credicash.loans/privacy_ios.html"
      }else{
          location.href="https://www.credicash.loans/privacy.html"
      }
    }
  },
};
</script>
<style scoped>
.header{
  width: 100%;
  height: 4.9rem;
  background: #FFBB12;
}

.header-info{
  margin: 0 auto;
  width: 6.88rem;
  height: 0.52rem;
  background: #FFFFFF;
  border-radius: 0rem 0rem 0.05rem 0.05rem;
  position: relative;
  z-index: 999;
   padding: 0 0.21rem;
  box-sizing: border-box;
}

.header-info::after{
  content: '';
  position: absolute;
  bottom: -0.08rem;
  width: 6.77rem;
  left: 0.055rem;
  height: 0.29rem;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 0.05rem 0.05rem 0.05rem 0.05rem;
  z-index: -1;
}

.header-logo{
  width: 1.29rem;
  height: 0.29rem;
}


.menu-item{
  margin-left: 0.22rem;
  height: 0.52rem;
  position: relative;
  cursor: pointer;
}

.menu-line{
  position: absolute;
  top: 0;
  width: 100%;
  height: 0.02rem;
  border-radius: 0rem 0rem 0rem 0rem;
}

.menu-line-active{
  background: #F95D44;
}

.menu-title{
  font-size: 0.09rem;
  font-weight: bold;
  height: 0.52rem;
  line-height: 0.52rem;
  columns: #492100;
  text-align: center;
}

.menu-title-active{
  color: #FFBB12;
}

.header-title{
  width: 3.92rem;
  height: 0.69rem;
}

.header-desc{
  margin-top: .1rem;
  width: 3.85rem;
  height: 0.34rem;
  font-size: 0.13rem;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #715709;
}
.app-store{
  width: 0.94rem;
  height: 0.31rem;
  cursor: pointer;
}

.google-play{
  margin-left: .16rem;
  width: 0.67rem;
  height: 0.17rem;
  cursor: pointer;

}

.header-banner{
  margin-left: .14rem;
  width: 2.81rem;
  height: 2.71rem;
}

.body1-img{
  display: block;
  margin: .52rem auto ;
  width: 3.57rem;
  height: 0.69rem;
}

.body1_bg{
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 1.06rem;
}

.body1-left{
  width: 0.31rem;
  height: 0.31rem;
}

.body1-left-title{
  margin-top: .16rem;
font-size: 0.13rem;
font-family: PingFang SC-Bold, PingFang SC;
font-weight: bold;
color: #715709;
}

.body1-left-desc{
  margin-top: .23rem;
  width: 2.61rem;
  height: 0.23rem;
  font-size: 0.21rem;
  color: #111111;
}

.checkout-img{
  width: 0.09rem;
  height: 0.09rem;
}

.checkout-desc{
  margin-left: 0.05rem;
font-size: 0.09rem;
font-weight: 400;
color: #111111;
}

.body1-right{
  margin-left: 1.25rem;
  width: 2.81rem;
  height: 2.95rem;
}

.body2-left{
  width: 2.81rem;
  height: 2.93rem;
}

.info{
  margin-top: .6rem;
  width: 100%;
  height: 3.44rem;
  background: rgba(255, 187, 18, 0.1);
  border-radius: 0rem 0rem 0rem 0rem;
  opacity: 1;
}

.info-img{
  display: block;
  margin: 0.52rem auto .1rem;
  width: 3.07rem;
  height: 0.69rem;
}

.info-title{
font-size: 0.09rem;
font-weight: bold;
color: #666666;
}

.info-item-img{
  width: 0.63rem;
  height: 0.63rem;
}

.info1-line{
  width: 0.79rem;
  height: 0.2rem;
}

.info-item-title{
font-size: 0.13rem;
font-weight: 500;
color: #1E1E1E;
font-weight: 700;
text-align: center;
}

.info-item-desc{
  margin-top: .22rem;
font-size: 0.09rem;
font-weight: 400;
color: #666666;
text-align: center;

}

.info2_title{
  display: block;
  margin: 0 auto;
  width: 2.4rem;
  height: 0.69rem;
}

.info-left{
  position: absolute;
  left: 0;
  top: 0;
  width: 3.58rem;
  height: 4.48rem;
}

.info2-left{
  width: 4.34rem;
  height: 3.34rem;
  margin-right: .19rem;
}

.info2-img{
  width: 0.42rem;
  height: 0.42rem;
}

.info2-item{
  margin-right: .16rem;
  margin-bottom: .16rem;
  padding-left: .1rem;
  padding-top: .16rem;
  width: 1.88rem;
  height: 1.61rem;
  background: #FFFFFF;
  box-shadow: 0rem 0.09rem 0.16rem 0.01rem rgba(255, 187, 18, 0.1);
  border-radius: 0.05rem 0.05rem 0.05rem 0.05rem;
  opacity: 1;
  box-sizing: border-box;
}

.info2-item-border{
  border: 0.01rem solid #FFBB12;
}

.info2-item-title{
  margin-top: .16rem;
font-size: 0.12rem;
font-weight: bold;
color: #1E1E1E;
}

.info2-item-desc{
  margin-top: .11rem;
  width: 1.2rem;
font-size: 0.09rem;
font-weight: 400;
color: #666666;
line-height: 1.5;
}

.footer{
  position: relative;
  margin-top: .85rem;
  background-color: #FFF8E6;
  background-image: url(/static/img/footer.png);
  width: 100%;
  height: 2.17rem;
}

.footer-img{
  margin-top: .68rem;
  width: 4.69rem;
  height: 0.34rem;
}

.footer-desc{
  margin-top: .21rem;
  width: 6.52rem;
font-size: 0.09rem;
font-weight: 400;
color: #492100;
text-align: center;
}

.footer-desc2{
margin-top: .04rem;
}

.allow-img{
  position: absolute;
  right: .23rem;
  bottom: .23rem;
  width: 0.23rem;
  height: 0.23rem;
}

.footer2{
  width: 100%;
height: 0.78rem;
background: #FFBB12;
}

.footer2-title{
   margin-top: .02rem;
font-size: 0.09rem;
font-weight: 400;
color: #492100;
text-align: center;
}
.footer2-desc{
  margin-top: .03rem;
font-size: 0.09rem;
font-weight: 400;
color: #492100;
}
.footer2-info{
  margin-top: .12rem;
}
.footer2-info-desc{
font-size: 0.07rem;
font-weight: 400;
color: #715709;
text-decoration: underline;
cursor: pointer;
}



* {
    margin: 0;
    padding: 0;
    line-height: 1;
   }
   .f-w{
     font-weight: 700;
   }
   .t-c{
     text-align: center;
   }
   .d-f{
     display: flex;
   }
   .j-c{
     justify-content: center;
   }
   .j-s{
     justify-content: space-between;
   }
   .a-c{
     align-items: center;
   }
   .a-e{
     align-items: flex-end;
   }
   .a-s{
     align-items: flex-start;
   }
   .f-c{
     flex-direction: column;
   }
   .f-s{
     justify-content: flex-start;
   }
   .f-e{
     justify-content: flex-end;
   }
   .f-wrap{
     flex-wrap: wrap;
   }

   .l-5{
     line-height: 1.5;
   }


</style>



// WEBPACK FOOTER //
// src/components/home.vue